<template>
    <div>
        <Header :headerData="headerData"></Header>
    <div class="container">
        <div class="tenant_filter">
            <a-select 
                v-if="userInfo.tenant_id == 1"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="tenantOptions"
                style="width:200px"
                @change="handleTenantChange"
            ></a-select>
        </div>
        <!-- <div class="header">
            <h3>{{$t('faultData.summary')}}</h3>
            <div class="col">
                <div class="header-cardBox">
                    <div class="header-cardBox-right">
                        <span>{{ $t('faultData.totalSale')}}</span> 
                        <span class="num">{{ totalSale }}</span>
                    </div>
                </div>
                <div class="header-cardBox">
                    <div class="header-cardBox-right">
                        <span>{{ $t('faultData.faultVehicleNum')}}</span> 
                        <span class="num">{{ faultVehicleNum }}</span>
                    </div>
                </div>
                <div class="header-cardBox">
                    <div class="header-cardBox-right">
                        <span>{{ $t('faultData.hasRideDataVehicleNum')}}</span> 
                        <span class="num">{{ hasRideDataVehicleNum }}</span>
                        
                    </div>
                </div>
                <div class="header-cardBox">
                    <div class="header-cardBox-right">
                        <span>{{ $t('faultData.faultDataRate')}}</span>
                        <span class="num">{{ vehicleFaultRatio }}</span>
                    </div>
                </div>
                <div class="header-cardBox">
                    <div class="header-cardBox-right">
                        <span>{{ $t('faultData.vehicleFaultRate')}}</span> 
                        <span class="num">{{ vehicleFaultRate }}</span>
                    </div>
                </div>
            </div>
        </div>    -->

        <div class="content">
            <div class="card">
                <h3 style="display:inline-block">
                    {{ $t('faultData.faultCodeRate') }}
                    <a-tooltip placement="right">
                        <template #title>
                            <span>{{$t('faultData.faultDetailTip')}}</span>
                        </template>
                        <question-circle-outlined class="questionIcon"/>
                    </a-tooltip>
                </h3>
                <div class="filter">
                    <a-select
                        ref="select"
                        v-model:value="type"
                        class="filterSelect"
                        allowClear
                        :disabled="!!top"
                        @focus="focus"
                        @change="handleSelectChange"
                    >
                        <a-select-option value="ECU">ECU</a-select-option>
                        <a-select-option value="Meter">METER</a-select-option>
                        <a-select-option value="BMS">BMS</a-select-option>
                    </a-select>

                    <a-select
                        ref="select"
                        v-model:value="top"
                        class="filterSelect"
                        :disabled="!!type"
                        allowClear
                        @focus="focus"
                        @change="handleTopSelectChange"
                    >
                        <a-select-option value="10">{{ $t('faultData.fault10') }}</a-select-option>
                        <a-select-option value="15">{{ $t('faultData.fault15') }}</a-select-option>
                        <a-select-option value="20">{{ $t('faultData.fault20') }}</a-select-option>
                    </a-select>

                    <a-select
                        ref="select"
                        v-model:value="category"
                        class="filterSelect"
                        allowClear
                        @focus="focus"
                        @change="handleCategorySelectChange"
                    >
                        <a-select-option value="0">{{ $t('faultData.marketVehicle') }}</a-select-option>
                        <a-select-option value="1">{{ $t('faultData.testVehicle') }}</a-select-option>
                    </a-select>

                    <a-select
                        ref="select"
                        v-model:value="status"
                        class="filterSelect"
                        allowClear
                        @focus="focus"
                        @change="handleStatusSelectChange"
                    >
                        <a-select-option value="0">{{ $t('faultData.riding') }}</a-select-option>
                        <a-select-option value="1">{{ $t('faultData.noRiding') }}</a-select-option>
                    </a-select>

                    <a-range-picker
                        v-model:value="dateRange"
                        style="margin:10px 0 0 15px; width:365px"
                        @change="changeDate"
                    />
                </div>

                <!-- <a-tooltip placement="right">
                    <template #title>
                        <span>{{$t('faultData.faultDetailTip')}}</span>
                    </template>
                    <question-circle-outlined style="margin-left:20px;font-size:20px"/>
                </a-tooltip> -->

                <!-- <a-spin :spinning="spinning"> -->
                    <div class="chart">
                        <div class="noData" v-if="vehicleList.length == 0">
                            <div>
                                <FolderOutlined style="font-size:50px"/>
                            </div>
                            {{ $t('base.noData')}}
                        </div>
                        <div id="code_chart_2"></div>
                    </div>
                    
                    <div class="chart">
                        <div class="noData" v-if="list.length == 0">
                            <div>
                                <FolderOutlined style="font-size:50px"/>
                            </div>
                            {{ $t('base.noData')}}
                        </div>
                        <div id="code_chart"></div>
                    </div>

                <!-- </a-spin> -->
            </div>

            <div class="card content-right">
                <h3>{{$t('faultData.weekSummary')}}</h3>
                <!-- <div class="content-right-cardBox"> -->
                    <a-date-picker 
                        v-model:value="weekRange"
                        :format="customWeekStartEndFormat"
                        :placeholder="$t('faultData.weekSearch')" 
                        style="width: 100%;"
                        picker="week" 
                        @change="onChangeWeek" 
                    >
                        <template #suffixIcon>
                            <clock-circle-outlined />
                        </template>
                    </a-date-picker>
                    <a-select
                        ref="select"
                        v-model:value="categoryWeek"
                        style="width: 100%;display: inline-block;margin-top: 10px; margin-left: 0;"
                        allowClear
                        @focus="focus"
                        @change="handleCategoryWeekSelectChange"
                    >
                        <a-select-option value="0">{{ $t('faultData.marketVehicle') }}</a-select-option>
                        <a-select-option value="1">{{ $t('faultData.testVehicle') }}</a-select-option>
                    </a-select>
                <!-- </div> -->
                <div class="content-right-cardBox">
                    <div class="icon_bg icon_bg_red">
                        <AlertTwoTone class="data_icon" two-tone-color="#eb2f96"/>
                    </div>
                    <div class="content-right-cardBox-right">
                        <span class="num">{{ faultVehicleNumWeek }}</span>
                        <span>{{ $t('faultData.faultVehicleNum')}}</span> 
                    </div>
                </div>
                <div class="content-right-cardBox">
                    <div class="icon_bg icon_bg_orange">
                        <CarTwoTone class="data_icon" two-tone-color="#ff8b58"/>
                    </div>
                    <div class="content-right-cardBox-right">
                        <span class="num">{{ hasRideDataVehicleNumWeek }}</span>
                        <span>{{ $t('faultData.hasRideDataVehicleNum')}}</span> 
                    </div>
                </div>
                <div class="content-right-cardBox">
                    <div class="icon_bg icon_bg_blue">
                        <PieChartTwoTone class="data_icon" two-tone-color="#4ab8ff"/>
                    </div>
                    <div class="content-right-cardBox-right">
                        <span class="num">{{ vehicleFaultRatioWeek }}</span>
                        <span>{{ $t('faultData.faultDataRate')}}</span>
                    </div>
                </div>
                <div class="content-right-cardBox">
                    <div class="icon_bg icon_bg_purple">
                        <FundTwoTone class="data_icon" two-tone-color="#713bdb"/>
                    </div>
                    <div class="content-right-cardBox-right">
                        <span class="num">{{ vehicleFaultRateWeek }}</span>
                        <span>{{ $t('faultData.vehicleFaultRateWeek')}}</span> 
                    </div>
                </div>
                
            </div>
        </div>

        <!-- 故障明细 -->
        <div v-dialogDrag id="modalBox" v-if="faultDetailVisible">
            <a-modal 
                v-model:visible="faultDetailVisible" 
                :title="$t('faultData.faultDetail')" 
                centered
                :footer="null"
                :getContainer="getContainer"
                :force-render="true" 
                width="85%"
            >
                <Table
                    :table="faultDetailTable"
                    @handleChangePagination="handleFaultDetailChangePagination"
                >
                </Table>
            </a-modal>
        </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue"
    import * as echarts from 'echarts'
    import 'echarts/extension/bmap/bmap'
    import Table from "@/components/Table.vue"
    import { useRoute, useRouter } from "vue-router"
    import { useI18n } from 'vue-i18n'
    import { message, Modal } from 'ant-design-vue'
    import { FaultApi } from '@/api/FaultApi.js'
    import Header from '@/layouts/component/Header.vue';
    import { getWeek } from '@/hooks/useGetWeek'
    import { newUseDateTimestamp } from '@/hooks/useDateTimestamp'
    import { getLastWeekDate, curDateTimestamp } from '@/utils/global'
    import dayjs from 'dayjs'
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js'
    

    const { t } = useI18n()

    const week = getWeek().week
    const currentDate = getWeek().currentDate
    const headerData = ref({
        menu:'menu.FaultDataBoard',
        menu_desc:'menu.subFaultData',
        week: getWeek().week,
        current_time:getWeek().currentDate,
    })
    const lang = ref(localStorage.getItem('lang') ? localStorage.getItem('lang') : '')
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const searchForm = reactive({
        tenant_id: (userInfo.value?.tenant_id == 1) ? '' : (userInfo.value?.tenant_id || ''),
    })
    const tenantOptions = ref([])
    const totalSale = ref(0) // 售车总数
    const faultVehicleNum = ref(0) // 故障整车数
    const hasRideDataVehicleNum = ref(0) // 骑行数据整车数
    const vehicleFaultRatio = ref(0) // 整车故障比例
    const vehicleFaultRate = ref(0) // 整车故障率
    const faultVehicleNumWeek = ref(0) // 故障整车数-按周查
    const hasRideDataVehicleNumWeek = ref(0) // 骑行数据整车数-按周查
    const vehicleFaultRatioWeek = ref(0) // 整车故障比例-按周查
    const vehicleFaultRateWeek = ref(0) // 整车故障率-按周查
    
    const list = ref([])
    const vehicleList = ref([])
    const type = ref('ECU')
    const top = ref('')
    const category = ref('0')
    const status = ref('')
    const categoryWeek = ref('0')
    const dateRange = ref([dayjs(getLastWeekDate(7), 'YYYY/MM/DD'), dayjs(getLastWeekDate(1), 'YYYY/MM/DD')]) // 默认日期范围为上一周
    const startDate = ref(new Date(`${getLastWeekDate(7)} 00:00:00`).getTime().toString().slice(0,10)) // 获取上周周一对应日期的时间戳
    const endDate = ref(new Date(`${getLastWeekDate(1)} 23:59:59`).getTime().toString().slice(0,10)) // 获取上周周日对应的期的时间戳
    const customWeekStartEndFormat = value => `${dayjs(value).startOf('week').format('YYYY/MM/DD')} ~ ${dayjs(value).endOf('week').format('YYYY/MM/DD')}` // 周日期显示格式化
    const weekRange = ref(dayjs()) // 周日期，值为当天日期
    const weekStart = ref() // 每周周一
    const weekEnd = ref() // 每周周日
    const spinning = ref(false)
    const faultDetailVisible = ref(false)
    const fault_code = ref('')
    const faultDetailTable = ref({
        data: [],
        columns: [
            {
                title: t('faultData.frame_number'), // 车架号
                dataIndex: 'frame_number',
                key: 'frame_number',
                width: 170,
            },
            {
                title: t('faultData.fault_code'), // 故障码
                dataIndex: 'fault_code',
                key: 'fault_code',
                width: 100,
            },
            {
                title: t('faultData.fault_parse_plaintext'), // 故障名称
                dataIndex: 'fault_parse_plaintext',
                key: 'fault_parse_plaintext',
                width: 170,
            },
            {
                title: t('faultData.fault_category'), // 故障分类
                dataIndex: 'fault_category',
                key: 'fault_category',
                width: 130,
            },
            {
                title: t('faultData.ride_no'), // 骑行编号
                dataIndex: 'ride_no',
                key: 'ride_no',
                width: 90,
            },
            // {
            //     title: t('upgradeLog.distance'), // 骑行距离
            //     dataIndex: 'distance',
            //     key: 'distance',
            //     width: 100,
            // },
            {
                title: t('faultData.occur_timestamp'), // 时间戳
                dataIndex: 'occur_timestamp',
                key: 'occur_timestamp',
                width: 140,
            },
        ],
        configs: {
            table: {
                rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${faultDetailTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })


    const handleSelectChange = async (val)=>{
        if(startDate.value == ''){
            message.error(t('base.pickDate'))
            return
        }
        type.value = val == undefined ? '' : val
        await getFaultCodeRate()
        renderChart()
        renderChart2()
    }

    const handleTopSelectChange = async (val)=>{
        if(startDate.value == ''){
            message.error(t('base.pickDate'))
            return
        }
        top.value = val == undefined ? '' : val
        await getFaultCodeRate()
        renderChart()
        renderChart2()
    }

    const handleCategorySelectChange = async (val)=>{
        if(startDate.value == ''){
            message.error(t('base.pickDate'))
            return
        }
        category.value = val == undefined ? '' : val
        await getFaultCodeRate()
        renderChart()
        renderChart2()
    }

    const handleStatusSelectChange = async (val)=>{
        if(startDate.value == ''){
            message.error(t('base.pickDate'))
            return
        }
        status.value = val == undefined ? '' : val
        await getFaultCodeRate()
        renderChart()
        renderChart2()
    }

    const handleCategoryWeekSelectChange = (val)=>{
        if(weekRange.value == ''){
            message.error(t('base.pickDate'))
            return
        }
        categoryWeek.value = val == undefined ? '' : val
        getFaultRideRateWeek()
        getFaultRateWeek()
    }

    const onChangeWeek = (val)=>{
        if(val == null){
            message.error(t('base.pickDate'))
            return
        }
        getWeekStartAndEndTimestamp(val)
    }

    const getContainer = () => {
        return document.getElementById('modalBox');
    }

    // 获取每周周一和周日时间戳，并调用故障率接口
    const getWeekStartAndEndTimestamp = (val)=>{
        let currentDayStart = curDateTimestamp(`${val.$y}-${val.$M + 1}-${val.$D}`).startDate
        let currentDayEnd = curDateTimestamp(`${val.$y}-${val.$M + 1}-${val.$D}`).endDate
        weekStart.value = Number(currentDayStart) - (val.$W - 1) * 24 * 60 * 60
        weekEnd.value = (7 - val.$W) * 24 * 60 * 60 + Number(currentDayEnd)
        getFaultRateWeek()
        getFaultRideRateWeek()
    }

    const changeDate = async (date,val)=>{
        // console.log(date,val,'date')
        if(date !== null){
            startDate.value = newUseDateTimestamp(date).startDate.value
            endDate.value = newUseDateTimestamp(date).endDate.value
            await getFaultCodeRate()
            renderChart()
            renderChart2()
        }else{
            message.error(t('base.pickDate'))
            startDate.value = ''
            endDate.value = ''
        }
    }

    // 图表
    const renderChart = ()=> {
        let seriesData = []
        if(list.value.length > 0){
            list.value.forEach(item=>{
                seriesData.push({
                    value:item.num,
                    name:item.fault_parse_plaintext,
                    text:item.fault_code == undefined? item.fault_parse_plaintext : `${item.fault_code}-${item.fault_parse_plaintext}`,
                    code:item.fault_code
                })
            })
        }

        nextTick(() => {
            let myChart = echarts.init(document.getElementById('code_chart'))
            myChart.clear()

            window.addEventListener("resize", () => {
                myChart.resize();
            });
 
            let option = {
                title:{
                    show:true,
                    text:  t('faultData.faultCodeDistribution'),
                    top:'5%',
                    left:'center',
                    textStyle:{
                        color:'#777',
                        fontSize:'15px'
                    }
                },
                toolbox:{
                    show:false,
                    top:'5%',
                    feature: {
                        dataView: { 
                            readOnly: true,
                            title:t('base.dataView'),
                            lang:[t('base.dataView'), t('base.close'), t('base.refresh')]
                        },
                        saveAsImage: {
                            title:t('base.downLoad'),
                        }
                    }
                },
                legend: {
                    top: '5%',
                    orient: 'vertical',
                    left:'left',
                    right:'80%'
                    // bottom:'bottom'
                },
                grid: {
                    left: '20%',
                    right: '0%',
                    bottom: '1%',
                    top: '20%',
                    containLabel: true
                },
                tooltip:{
                    formatter(param) {
                        // console.log(param,'ppp')
                        return `【${param.data.text}】 ${param.data.value}`
                    }
                },
                series: [
                    {
                        name:'',
                        type: 'pie',
                        radius: '35%',
                        data: seriesData,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: `【{b}】{d}%` //显示百分比
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            } 
                        }
                    }
                ]
            }

            if(list.value.length > 0){
                myChart.setOption(option)
            }

            myChart.off('click');
            myChart.on('click', (params)=> {
                faultDetailVisible.value = true
                fault_code.value = params.data.name
                faultDetailTable.value.configs.pagination.current = 1
                getFaultDetail(fault_code.value)
            });
            
        })
    }

    const renderChart2 = ()=> {
        let seriesData = []
        if(vehicleList.value.length > 0){
            vehicleList.value.forEach(item=>{
                seriesData.push({
                    value:item.num,
                    name:item.fault_parse_plaintext,
                    text:item.fault_code == undefined? item.fault_parse_plaintext : `${item.fault_code}-${item.fault_parse_plaintext}`,
                })
            })
        }

        nextTick(() => {
            let myChart = echarts.init(document.getElementById('code_chart_2'))
            myChart.clear()

            window.addEventListener("resize", () => {
                myChart.resize();
            });

            let option = {
                title:{
                    show:true,
                    text: t('faultData.vehicleFaultCodeDistribution'),
                    top:'5%',
                    left:'center',
                    textStyle:{
                        color:'#777',
                        fontSize:'15px'
                    }
                },
                toolbox:{
                    show:false,
                    top:'5%',
                    feature: {
                        dataView: { 
                            readOnly: true,
                            title:t('base.dataView'),
                            lang:[t('base.dataView'), t('base.close'), t('base.refresh')]
                        },
                        saveAsImage: {
                            title:t('base.downLoad'),
                        }
                    }
                },
                legend: {
                    top: '5%',
                    orient: 'vertical',
                    left: 'left',
                    right:'80%'
                },
                grid: {
                    left: '20%',
                    right: '0%',
                    bottom: '1%',
                    top: '20%',
                    containLabel: true
                },
                tooltip:{
                    formatter(param) {
                        return `【${param.data.text}】 ${param.data.value} 辆`
                    }
                },
                series: [
                    {
                        name:'',
                        type: 'pie',
                        radius: '35%',
                        data: seriesData,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                            normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: `【{b}】 {d}%` //显示百分比
                                }, 
                                labelLine :{
                                    show:true
                                } 
                            } 
                        }
                    }
                ]
            }

            if(list.value.length > 0){
                myChart.setOption(option)
            }
        })
    }

    //故障明细列表分页
    const handleFaultDetailChangePagination = (config, data)=> {
        faultDetailTable.value.configs.pagination.current = config.current
        faultDetailTable.value.configs.pagination.pageSize = config.pageSize
        getFaultDetail(fault_code.value)
    }

    // 获取激活整车的故障比例,查询全部
    const getFaultRate = async ()=>{
        let param = { 
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id
        }
        let res = await FaultApi.getInstance().getFaultRate(param)
        if(res.code === 0){
            vehicleFaultRatio.value = ((res.data.fault / res.data.total) * 100).toFixed(2) + '%'
            totalSale.value = res.data.total
            faultVehicleNum.value = res.data.fault
        }else{
            message.error(res.msg)
        }
    }

    // 整车故障率,查询全部
    const getFaultRideRate = async ()=>{
        let param = { 
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id
        }
        let res = await FaultApi.getInstance().getFaultRideRate(param)
        if(res.code === 0){
            vehicleFaultRate.value = ((res.data.fault / res.data.rides) * 100).toFixed(2) + '%'
            hasRideDataVehicleNum.value = res.data.rides
        }else{
            message.error(res.msg)
        }
    }

    // 获取激活整车的故障比例,按周查询
    const getFaultRateWeek = async ()=>{
        let param = {
            start:weekStart.value,
            end:weekEnd.value,
            category:categoryWeek.value,  
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id,
        }
        let res = await FaultApi.getInstance().getFaultRate(param)
        if(res.code === 0){
            vehicleFaultRatioWeek.value = res.data.fault == 0 || res.data.total == 0? '0%' : ((res.data.fault / res.data.total) * 100).toFixed(2) + '%'
            faultVehicleNumWeek.value = res.data.fault
        }else{
            message.error(res.msg)
        }
    }

    // 整车故障率,按周查询
    const getFaultRideRateWeek = async ()=>{
        let param = {
            start:weekStart.value,
            end:weekEnd.value,
            category:categoryWeek.value,  
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id,
        }
        let res = await FaultApi.getInstance().getFaultRideRate(param)
        if(res.code === 0){
            vehicleFaultRateWeek.value = res.data.fault == 0 || res.data.rides == 0? '0%' : ((res.data.fault / res.data.rides) * 100).toFixed(2) + '%'
            hasRideDataVehicleNumWeek.value = res.data.rides
        }else{
            message.error(res.msg)
        }
    }

    // 获取故障码上报比例
    const getFaultCodeRate = async ()=>{
        let param = {
            type:type.value,
            top:top.value,
            category:category.value,
            status:status.value,  
            start:startDate.value,
            end:endDate.value,
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id,
        }
        spinning.value = true
        let res = await FaultApi.getInstance().getFaultCodeRate(param) 
        if(res.code === 0){
            list.value = []
            vehicleList.value = []
            list.value = res.data.list
            vehicleList.value = res.data.vehicleList
            spinning.value = false
        }else{
            message.error(res.msg)
        }
    }

    // 查询故障明细列表
    const getFaultDetail = async (text)=>{
        let param = {
            fault_parse_plaintext:text,
            vehicle_category:category.value,  
            begin_date:startDate.value,
            end_date:endDate.value,
            status_category:status.value,
            sys_org: userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id,
        }
        let page_num = faultDetailTable.value.configs.pagination.current
        let page_size = faultDetailTable.value.configs.pagination.pageSize
        faultDetailTable.value.configs.loading = true
        let res = await FaultApi.getInstance().getFaultDetail(param,page_num,page_size)
        if(res.code === 0){
            res.data.records.forEach(i=>{
                i.fault_code = i.fault_code == undefined? '-' : i.fault_code
            })
            faultDetailTable.value.data = res.data.records
            faultDetailTable.value.configs.pagination.total = res.data.total
            faultDetailTable.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            tenantOptions.value = (res.data || []).map(item=>({ label: item.tenant_name, value: item.tenant_id }))
            if(userInfo.value.tenant_id == 1){
                tenantOptions.value.unshift({ label: t('access.allTenant'), value: '' })
            }
        } else {
            message.error(res.msg || res.message);
        }
    }

    const handleTenantChange = async ()=>{
        await getFaultRate()
        await getFaultRideRate()
        await getFaultCodeRate()
        renderChart()
        renderChart2()
        if(weekStart.value && weekEnd.value){
            await getFaultRateWeek()
            await getFaultRideRateWeek()
        }
    }

    onMounted(async ()=>{
        await getTenantList()
        getWeekStartAndEndTimestamp(weekRange.value)
        getFaultRate()
        getFaultRideRate()
        await getFaultCodeRate()
        renderChart()
        renderChart2()
    })
</script>

<style lang="scss" scoped>
.layout_content{
    background: #f3f3f3;
}
.header{
    display: flex;
    flex-direction: column ;
    box-shadow: 1px 1px 16px -13px #333;

    h3{
        padding: 10px 10px 0 25px;
        font-weight: bold;
        margin-bottom: 0;
    }

    .col{
        display: flex;
        flex: 1;
    }

    .header-cardBox{
        display: flex;
        flex-direction: row;
        margin: 5px 0;
        padding: 10px 0;
        width: 50%;
        font-size: 14px;
        color: #777;
        border-radius: 3px;
        box-shadow: none;

        .header-cardBox-right{
            display: flex;
            flex: 1;
            flex-direction: column;
            align-items: center;
            border-right: 1px solid #eee;
            span{
                display: block;
                color: #333;
                font-size: 13px;
                font-weight: bold;
            }
            .num{
                font-size: 30px;
                font-weight: bold;
                color: #5470c6;
            }   
        }
    }

    .header-cardBox:nth-last-child(1){
        .header-cardBox-right {
            border-right: none;
        }
    }
}

.container{
    margin-top: 30px;
}

.tenant_filter{
    margin: 0 0 10px 0px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

.content{
    display: flex;
}

.card{
    width: 74%;
    margin-top:10px;
    padding: 15px;
    box-shadow: 1px 1px 12px -7px #333;

    h3{
        font-weight: bold;
    }

    .noData{
        text-align: center;
        color: #666;
    }

    .questionIcon{
        margin-left: 5px;
        margin-top: -3px;
        vertical-align: middle;
        font-size: 17px;
    }

    .filter{
        padding: 0;
        margin-left: -15px;
        

        .filterSelect{
            display: inline-block;
            margin-left: 15px;
            margin-top: 10px;
            width: 175px;
        }
    }
}

.content-right{
    margin-left: 10px;
    width: 26%;
    padding: 15px;

    .content-right-cardBox{
        display: flex;
        flex-direction: row;
        margin: 10px 0;
        padding: 15px;
        font-size: 14px;
        color: #777;
        border-radius: 3px;
        box-shadow: 1px 1px 16px -13px #333;

        .ant-picker{
            width: 300px;
        }
        .data_icon{
            font-size: 25px;
        }
        .icon_bg{
            display: inline-block;
            margin-right: 12px;
            width: 65px;
            height: 65px;
            border-radius: 50%;
            text-align: center;
            line-height: 71px;
        }
        .icon_bg_red{
            background: #ffeff2;
        }
        .icon_bg_orange{
            background: #fef3ef;
        }
        .icon_bg_blue{
            background: #edf8fe;
        }
        .icon_bg_purple{
            background: #f2ebfb;
        }
        .content-right-cardBox-right{
            display: flex;
            flex: 1;
            flex-direction: column;
            span{
                display: block;
            }
            .num{
                font-size: 30px;
                font-weight: bold;
                color: #333;
            }   
        }
    }
}

.chart{
    position: relative;

    #code_chart,
    #code_chart_2{
        width: 100%;
        height: 800px;
        border-bottom:1px solid #eee;
    }

    .noData{
        position: absolute;
        top: 50%;
        left: 50%;
    }
}

// 故障明细表格行距样式（参照APPVersion表格）
#modalBox {
    ::v-deep .ant-table-wrapper .ant-table-tbody > tr > td,
    ::v-deep .ant-table-wrapper tfoot > tr > td {
        padding: 6px 16px !important;
    }
}
</style>